module.exports = __webpack_public_path__ + "img/course-item-d.16665842.png";